import { Lineicons } from '@lineiconshq/react-lineicons';
import { Gear1Stroke } from '@lineiconshq/free-icons';
import { Save, Trash2 } from 'lucide-react';
import React from 'react';
import { FormFieldV2, MenuButtonV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface Props {
  formMode: 'add' | 'edit' | 'view';
}

const OtherTab = ({ formMode }: Props) => {
  return (
    <div className='space-y-4 p-4'>
      {/* Số chứng từ (từ/đến) */}
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Số c/từ (từ/đến)</Label>
        <div className='flex flex-1 gap-x-2'>
          <FormFieldV2
            name='so_ct_tu'
            type='text'
            disabled={formMode === 'view'}
            className='max-w-[150px] flex-1'
            placeholder='Từ'
          />
          <FormFieldV2
            name='so_ct_den'
            type='text'
            disabled={formMode === 'view'}
            className='max-w-[150px] flex-1'
            placeholder='Đến'
          />
        </div>
      </div>

      {/* Mẫu lọc báo cáo */}
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Mẫu lọc báo cáo</Label>
        <div className='flex flex-1 items-center gap-2'>
          <FormFieldV2
            name='mau_loc_bao_cao'
            type='select'
            disabled={formMode === 'view'}
            options={[
              { value: '0', label: 'Người dùng tự lọc' },
              { value: '1', label: 'Mẫu lọc 1' },
              { value: '2', label: 'Mẫu lọc 2' }
            ]}
            className='max-w-[300px]'
          />

          <div className='h-9 w-9 flex-shrink-0'>
            <MenuButtonV2
              title=''
              icon={<Lineicons aria-hidden='true' icon={Gear1Stroke} size={18} />}
              className='h-9 w-9 px-0 py-0'
              items={[
                {
                  title: 'Lưu mẫu mới',
                  icon: Save,
                  onClick: () => console.log('Save new filter template')
                },
                {
                  title: 'Lưu đè vào mẫu đang chọn',
                  icon: Save,
                  onClick: () => console.log('Overwrite current filter template')
                },
                {
                  title: 'Xóa mẫu đang chọn',
                  icon: Trash2,
                  onClick: () => console.log('Delete current filter template')
                }
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherTab;
